import React from 'react';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import alertService from '../../../../services/AlertService';
import { handleError } from '../../../../utils/apiUtils';

type Props = {
  trainingType: 'Pathway' | 'Course';
  unpublish: () => Promise<void>;
  handleDismiss: () => void;
};

export const UnpublishTrainingModal = ({ trainingType, unpublish, handleDismiss }: Props) => {
  const trainingTypeLower = trainingType.toLowerCase();

  const handleSubmit = () =>
    unpublish()
      .then(() => {
        alertService.show(`${trainingType} Unpublished`);
        handleDismiss();
      })
      .catch(error => {
        handleError(error);
        handleDismiss();
      });

  return (
    <ConfirmationModal
      title={`Unpublish ${trainingType}`}
      prompt={<>Are you sure you want to unpublish this {trainingTypeLower}?</>}
      buttonActionText="Unpublish"
      buttonType="danger"
      handleSubmit={handleSubmit}
      handleDismiss={handleDismiss}
    >
      Unpublishing this {trainingTypeLower} prevents it from being assigned to people in your church and removes it from
      search
    </ConfirmationModal>
  );
};
